import "./MainContent.scss";

function MainContent({ children }) {
  return <div className="main-content">{children}</div>;
}

export default MainContent;
